import { useEffect } from "react";
import { isCoachEntitled } from "./agentGating";

// Whether the signed-in user may run the coach (PLEX-6523), for a component
// that picks the session agent. Starts loading
// /me/entitlements once the user is signed in (loadMine is idempotent), and
// reads the store during render, so an observer re-renders when it resolves.
const useCoachEntitled = (userStore, entitlementsStore) => {
  const authReady = !!userStore?.authData;
  useEffect(() => {
    if (authReady) entitlementsStore?.loadMine();
  }, [authReady, entitlementsStore]);
  return isCoachEntitled({ entitlementsStore, isAdmin: userStore?.isAdmin });
};

export default useCoachEntitled;
